import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { useEmploymentInfo } from '../../../employment/useEmployment';
import { usePensionEnrollmentInfo } from '../../../pension-enrollment/hooks/usePensionEnrollmentInfo';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { PensionEnrollmentPlan, PensionEnrollmentState } from '../../../pension-enrollment/models/pension-enrollment-model';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { getLetterMonthDate } from '../../../../../../global/helpers/date-helpers';
import { WysiwygWithReactLink } from '../../../../../../global/components/wysiwyg-with-react-link';
import { useOnlyOtpEmployment } from '../../hooks/useNewhireEnrollmentAllowed';
import { LabelAndValue } from '../../../../../../global/components/data-display/label-value';
import { ExcludedPensionID } from '../../models/pension-enrollment-models';


interface Props {
	settings: NewHireProps;
	editLink: JSX.Element;
}
export function PensionReview(props: Props) {

	const { settings, editLink } = props;
	const pensionInfoLoaded = usePensionEnrollmentInfo();
	const employmentLoaded = useEmploymentInfo();
	const pensionEnrollmentState = useSelector<TcsmStates, PensionEnrollmentState>(state => state.pensionEnrollmentState);
	const enrolledPlans = pensionEnrollmentState?.pensionInfo?.enrolled_plans;
	const onlyOtp = useOnlyOtpEmployment();
	if (!pensionInfoLoaded || !employmentLoaded) {
		return <LoadingCircle />;
	}

	const isNoPreTax = (planToEvaluate: PensionEnrollmentPlan) => {
		return planToEvaluate?.pbpor_id !== ExcludedPensionID.LAY_DB_PENSION_PLAN_ID && planToEvaluate?.pbpor_id !== ExcludedPensionID.CLERGY_DB_PENSION_PLAN_ID;
	};

	if (onlyOtp) {
		return null;
	}

	function RenderContribution(enrolledPlan: PensionEnrollmentPlan) {
		if (!enrolledPlan?.employee_contribution) return null;

		return (
			<ContentSpacer>
				<p><strong>{settings?.contributionLabel}</strong></p>
				<p>{enrolledPlan?.employee_contribution}</p>
			</ContentSpacer>
		);
	}

	return (
		<DividerSection sectionText={settings?.reviewPensionSectionTitle} secondarySectionNode={editLink} >
			{
				enrolledPlans?.length > 0 ?
					enrolledPlans?.map(enrolledPlan => {
						return (
							<ContentSpacer>
								<ContentSpacer>
									<h3>{enrolledPlan?.product?.description}</h3>
								</ContentSpacer>
								{
									RenderContribution(enrolledPlan)
								}
								<ContentSpacer>
									{
										isNoPreTax(enrolledPlan) && (
											<LabelAndValue  label={settings?.preTaxContributionLabel} value={ enrolledPlan?.pretax_contribution}/>
										)
									}
									<LabelAndValue  label={settings?.effectiveDateLabel} value={getLetterMonthDate(enrolledPlan?.enrollment_effective_date)}/>
								</ContentSpacer>
							</ContentSpacer>
						);
					})
					:
					<ContentSpacer>
						<WysiwygWithReactLink content={settings?.noRetirementPlanEnrolledMessageForAdminReviewPage} />
					</ContentSpacer>
			}

		</DividerSection>
	);
}